/**
 * useLearningBoard — кто играет в учебных играх дня расстановки (13.10, владелец: «в учебных играх …
 * указать, кто из сотрудников и принятых на работу будет играть, и при расстановке чтобы у ОО была
 * возможность запросить отчёты … друг о друге»).
 *   GET /api/bookings/learning?date=  — игроки учебных игр дня И следующего дня; оставляем только игры
 *                                       доски (свои с 06:00 + ночной хвост D+1 — тот же отбор, что у игр
 *                                       в useOoDay; время брони сервер не отдаёт, поэтому — по id игр доски)
 * Игроки — не назначения: ни зарплаты, ни грейдов, ни чипа состава (лассо их не копирует).
 */
import { useEffect, useMemo, useState } from "react";
import { api } from "../api/client";
import type { ApiList } from "../api/types";
import { fmtDateApi } from "../utils/date";
import type { BoardGame } from "./useOoDay";

export interface LearningPlayer {
  id: string;
  name: string;
}

interface RawPlayer { booking_id: number | string; staff_id: string; name?: string | null }

export function useLearningBoard(date: Date, games: BoardGame[]) {
  const [rows, setRows] = useState<RawPlayer[]>([]);

  /* перечитываем вместе с доской: новые games = доска перезагрузилась (сохранили, сменили день);
     пока доска пустая (первая загрузка) — не спрашиваем: показывать игроков всё равно не у чего */
  useEffect(() => {
    if (!games.length) return;
    let alive = true;
    api<ApiList<RawPlayer>>(`/api/bookings/learning?date=${fmtDateApi(date)}`)
      .then((r) => { if (alive) setRows(r.results ?? []); })
      .catch(() => { if (alive) setRows([]); });
    return () => { alive = false; };
  }, [date, games]);

  /** bookingId → игроки (по алфавиту — так отдаёт сервер). */
  const byBooking = useMemo(() => {
    const ids = new Set(games.map((g) => g.id));
    const map: Record<string, LearningPlayer[]> = {};
    for (const r of rows) {
      const bid = String(r.booking_id);
      if (!ids.has(bid)) continue;
      (map[bid] ??= []).push({ id: String(r.staff_id), name: r.name || String(r.staff_id) });
    }
    return map;
  }, [rows, games]);

  return { byBooking };
}
